module.exports = __webpack_public_path__ + "fonts/VetoSansCond-CondLight.69f33cf1.eot";